import { render, staticRenderFns } from "./LinksNewsletter.vue?vue&type=template&id=453b1734&"
import script from "./LinksNewsletter.vue?vue&type=script&lang=js&"
export * from "./LinksNewsletter.vue?vue&type=script&lang=js&"
import style0 from "./LinksNewsletter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports